import React, { useState, useEffect } from 'react';

let ws;
const Redis = () => {
  const [socket, setSocket] = useState(null);
  const [list, setList] = useState([]);

  const _connect = async () => {
    ws = new WebSocket('wss://queue.aniplustv.com');
    setSocket(ws);
    console.log('start 1');

    ws.onopen = async () => {
      console.log('...connect...');

      ws.send(
        JSON.stringify({
          //   type: 'getReservationList',
          type: 'getQueue',
          data: { userId: 'admin' },
        })
      );
    };
    ws.onmessage = (message) => {
      const { type, data, reservationCount } = JSON.parse(message.data);
      switch (type) {
        case 'queueData':
          //   console.log(data);
          if (data) {
            setList(data);
          }
          break;
        default:
          break;
      }
    };
  };
  const _enterReservation = (userid) => {
    console.log(userid);
    ws.send(JSON.stringify({ type: 'forceEnter', data: { userId: userid } }));
  };

  const _allEnter = async () => {
    for (const item of list) {
      ws.send(JSON.stringify({ type: 'forceEnter', data: { userId: item } }));
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
  };
  useEffect(() => {
    _connect();
  }, []);

  return (
    <div style={{ paddingTop: 100, paddingLeft: 50 }}>
      <div style={{ color: 'red', padding: 5 }} onClick={_allEnter}>
        [전체 입장]
      </div>
      {list.map((item) => (
        <div style={{ color: '#ffffff', padding: 5 }}>
          {item}
          <span
            style={{ marginLeft: 30, color: 'red', cursor: 'pointer' }}
            onClick={() => _enterReservation(item)}
          >
            [입장]
          </span>
        </div>
      ))}
    </div>
  );
};

export default Redis;
